import React from 'react';
import DashboardSidebar from '../components/DashboardSidebar';
import AdminBlogManagement from '../components/AdminBlogManagement';

const AdminContentPage = () => {
  return (
    <>
      <DashboardSidebar userRole="admin" />
      <div style={{ minHeight: '100vh', background: '#f8fafc', padding: '40px 20px', marginLeft: '280px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <AdminBlogManagement />
        </div>
      </div>
    </>
  );
};

export default AdminContentPage;
